import DataLoader from 'app/ui_v2/components/data-loader/DataLoader';
import { lazy, Suspense } from 'react';
import { Navigate, RouteObject } from 'react-router';

// Lazy load guards and layouts
const HasToBeInspectorGuard = lazy(() => import('app/core/guards/HasToBeInspectorGuard'));
const HasToBeLoggedInGuard = lazy(() => import('app/core/guards/HasToBeLoggedInGuard'));
const DefaultLayout = lazy(() => import('app/core/layout/DefaultLayout'));
const Error404Page = lazy(() => import('app/main/errors/Error404Page'));
const InspectorMessagingRedirectPage = lazy(
  () => import('app/main/inspector/messaging/InspectorMessagingRedirectPage'),
);

// Lazy load page components
const InspectorDashboard = lazy(() => import('../../../main/inspector/dashboard/InspectorDashboard'));
const ScheduledInspections = lazy(() => import('../../../main/inspector/scheduled-inspections/ScheduledInspections'));
const InspectorSettingsPage = lazy(() => import('../../../main/inspector/settings/InspectorSettingsPage'));
const InspectorProfilePage = lazy(() => import('../../../main/construction/inspectors/profile/InspectorProfilePage'));

const InspectorCreateThreadPage = lazy(() => import('../../../main/inspector/messaging/InspectorCreateThreadPage'));
const InspectorMessagingPage = lazy(() => import('../../../main/inspector/messaging/InspectorMessagingPage'));
const InspectorNotificationLandingPage = lazy(
  () => import('../../../main/inspector/messaging/InspectorNotificationLandingPage'),
);

const PREFIX = '/inspector';

const inspectorRoutes: RouteObject[] = [
  {
    path: PREFIX,
    element: (
      <HasToBeLoggedInGuard>
        <HasToBeInspectorGuard>
          <DefaultLayout />
        </HasToBeInspectorGuard>
      </HasToBeLoggedInGuard>
    ),
    errorElement: <Error404Page />,
    children: [
      {
        path: 'dashboard',
        element: (
          <Suspense fallback={<DataLoader />}>
            <InspectorDashboard />
          </Suspense>
        ),
      },
      {
        path: 'scheduled-inspections',
        element: (
          <Suspense fallback={<DataLoader />}>
            <ScheduledInspections />
          </Suspense>
        ),
      },
      {
        path: 'settings',
        element: <Navigate to={PREFIX + '/settings/general'} />,
      },
      {
        path: 'settings/:sectionId',
        element: (
          <Suspense fallback={<DataLoader />}>
            <InspectorSettingsPage />
          </Suspense>
        ),
      },
      {
        path: 'profile/:sectionId',
        element: (
          <Suspense fallback={<DataLoader />}>
            <InspectorProfilePage />
          </Suspense>
        ),
      },
      {
        path: 'profile',
        element: (
          <Suspense fallback={<DataLoader />}>
            <InspectorProfilePage />
          </Suspense>
        ),
      },

      // MESSAGES SECTION
      {
        path: 'messaging',
        element: <Navigate to={'/inspector/messaging/inbox'} />,
      },
      {
        path: 'messaging/create-thread/:recipientId/:jobId',
        element: (
          <Suspense fallback={<DataLoader />}>
            <InspectorCreateThreadPage />
          </Suspense>
        ),
      },
      {
        path: 'messaging/create-thread/:recipientId',
        element: (
          <Suspense fallback={<DataLoader />}>
            <InspectorCreateThreadPage />
          </Suspense>
        ),
      },
      {
        path: 'messaging/:sectionId',
        element: (
          <Suspense fallback={<DataLoader />}>
            <InspectorMessagingPage />
          </Suspense>
        ),
      },
      {
        path: 'messaging/:sectionId/:threadId',
        element: (
          <Suspense fallback={<DataLoader />}>
            <InspectorMessagingPage />
          </Suspense>
        ),
      },
      {
        path: 'notifications/:messageId',
        element: (
          <Suspense fallback={<DataLoader />}>
            <InspectorNotificationLandingPage />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: '/imi',
    element: <InspectorMessagingRedirectPage />,
  },
  {
    path: '/imi/:id',
    element: <InspectorMessagingRedirectPage />,
  },
];

export default inspectorRoutes;
